module.exports = __webpack_public_path__ + "static/media/nilgunbio.71f7ace0.jpg";